import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'

import FranchiseMerchantSwitcher from '@/components/franchise/FranchiseMerchantSwitcher.vue'
import SecondaryTop from '@/components/SecondaryTop.vue'
import { serverDayToDateObject } from '@/helpers/dates'


export default {
  __name: 'FranchiseDayHeader',
  props: {
  date: { type: String, required: true },
  backLink: { type: String, required: true },
  backName: { type: String, required: true },
  sections: { type: Array, default: undefined }
},
  emits: ['change'],
  setup(__props, { emit: __emit }) {

const props = __props
// The location chosen in the switcher (null for all of them). The page switches the store, once the
// lists that read the object cache are gone: a reset under a mounted list crashes its rows.
const emit = __emit

const LONG_DATE = new Intl.DateTimeFormat('en-US', { weekday: 'long', month: 'long', day: 'numeric' })

// SecondaryTop's back link takes where it goes and what it says.
const parent = computed(() => ({ link: props.backLink, name: props.backName }))

const longDate = computed(() => {
  const parsed = serverDayToDateObject(props.date)
  return parsed ? LONG_DATE.format(parsed) : ''
})

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(SecondaryTop, {
    parent: parent.value,
    text: "Production day",
    description: longDate.value,
    sections: __props.sections
  }, {
    right: _withCtx(() => [
      _createVNode(FranchiseMerchantSwitcher, {
        "all-label": "All locations",
        "switch-store": false,
        onChange: _cache[0] || (_cache[0] = id => emit('change', id))
      })
    ]),
    _: 1
  }, 8, ["parent", "description", "sections"]))
}
}

}